export default __webpack_public_path__ + "media/images/front/about/features/accommodation-79a1e36a47acdce7743daf6a98cfc4db.png";